import React, { useContext } from 'react'
import { Link } from 'react-router-dom'
import { ExamCompassContext } from '../Context/context'


const Dftj:React.FC = () => {
    const { toDashboard } = useContext(ExamCompassContext)
  
  return (
    <section className='py-16'>
      <div className='container'>
        <div className='lg:w-[1040px] h-[348px] mx-auto bg-darkGreen rounded-[8px] flex flex-col items-center justify-center'>
          <div className='mb-7 lg:mb-10'>
            <p className='text-whiteText text-[30px] md:text-[36px] text-center font-semibold mb-7 lg:mb-10'>Don’t forget to Join</p>
            <p className='text-whiteText text-center px-5 lg:px-36 leading-[28px]'>Don’t miss out on the opportunity to unlock your full potential with ExamCompass! Register now to access tailored notes, practice quizzes, and live competitions designed to help you ace your UTME. Take the first step towards success today!</p>
          </div>
          {localStorage.getItem('authToken') || sessionStorage.getItem('authToken')
            ? <button onClick={toDashboard && toDashboard} className='bg-whiteText text-darkGreen w-[300px] md:w-[404px] h-[38px] rounded-[4px]'>Go To Dashboard</button>
            : <Link to={'/register'}><button className='bg-whiteText text-darkGreen w-[300px] md:w-[404px] h-[38px] rounded-[4px]'>Start Practicing</button></Link>}
        </div>
      </div>
    </section>
  )
}

export default Dftj